import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Inbox } from "lucide-react";

/** Navbar bell linking to /notifications with unread badge. Polls every 60s. */
export function InboxBell() {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    if (!user) return;
    const load = () => api.get("/notifications/inbox", { params: { limit: 1 } }).then((r) => setUnread(r.data.unread || 0)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("nexus-inbox-read", load);
    return () => { clearInterval(t); window.removeEventListener("nexus-inbox-read", load); };
  }, [user]);
  if (!user) return null;
  return (
    <Link to="/notifications" className="relative h-9 w-9 rounded-full flex items-center justify-center text-zinc-300 hover:text-white hover:bg-white/5" aria-label="Notifications" data-testid="inbox-bell">
      <Inbox className="h-4 w-4" />
      {unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full nexus-gradient text-[10px] font-bold text-white flex items-center justify-center" data-testid="inbox-unread-badge">{unread > 99 ? "99+" : unread}</span>}
    </Link>
  );
}
